import { useEffect, useRef, useState } from "react";
import { useCentrifugeClient } from "../context/CentrifugeContext";

/**
 * Realtime-подписка на канал юнита (rtchnl{unitId}) поверх общего
 * Centrifuge-клиента из CentrifugeContext.
 *
 * Возвращает саму подписку, а не только распарсенные данные — часть
 * существующей бизнес-логики (Main.jsx: drawStats/fetchData) явно вызывает
 * subscription.subscribe()/unsubscribe() в зависимости от того, смотрит ли
 * пользователь на "сегодня" или на историческую дату. Это осознанно не
 * спрятано внутрь хука, чтобы не терять эту возможность управления.
 *
 * onMessage передаётся через ref, поэтому переподписка происходит только
 * при смене client/unitId, а не на каждый рендер из-за того, что onMessage
 * в Main.jsx — обычная функция, пересоздаваемая каждый рендер.
 */
export function useUnitRealtime(unitId, onMessage) {
	const client = useCentrifugeClient();
	const [subscription, setSubscription] = useState(null);

	const onMessageRef = useRef(onMessage);
	onMessageRef.current = onMessage;

	useEffect(() => {
		if (!client || !unitId) {
			setSubscription(null);
			return undefined;
		}

		const channel = `rtchnl${unitId}`;
		const newSubscription = client.newSubscription(channel);

		const handlePublication = (ctx) => onMessageRef.current?.(ctx);
		newSubscription.on("publication", handlePublication);

		setSubscription(newSubscription);

		return () => {
			newSubscription.unsubscribe();
			newSubscription.removeAllListeners();
			client.removeSubscription(newSubscription);
		};
	}, [client, unitId]);

	return { subscription };
}
